import { useMemo, useState, useEffect } from 'react'
import { numberFormat, round } from "shared/util"

import { KojinSisetuCollaborateRecord } from "./data"

import { ListRecordWithBar } from 'components/controls/listRecordWithBar'

import {
  Stack, Box, BoxProps, Typography, Alert, List,
  Tooltip, Button
} from "@mui/material"

import { OutboundIcon } from 'shared/icons'

import { SisetuDoctorsConditions } from '../condition'

type CollaborateData = {
  list: KojinSisetuCollaborateRecord[]
  total: number
  max: number
}

const INITIAL_SHOW_COUNT = 9

type CollaborateListSectionProps = {
  sisetuCode: string
  dataList?: KojinSisetuCollaborateRecord[]
  condition: SisetuDoctorsConditions
  onChangeCondition: (axis: 'collabo', condition: { code: string, name: string }) => void
  onSisetuOpen: (sisetuCode: string) => void
} & BoxProps
export const CollaborateListSection = ({
  sisetuCode,
  dataList,
  condition,
  onChangeCondition,
  onSisetuOpen,
  ...others
}: CollaborateListSectionProps) => {
  const [showAll, setShowAll] = useState<boolean>(false)
  
  const summary = useMemo<CollaborateData | null>(
    () => {
      if (!dataList) return null

      const list = dataList
      list.sort((a, b) => b.kojinCount - a.kojinCount)

      const { total, max } = list.reduce((acc, record) => ({
        total: acc.total + record.kojinCount,
        max: Math.max(acc.max, record.kojinCount)
      }), {
        total: 0,
        max: 0
      })
      return { list, total, max }
    },
    [dataList]
  )
  useEffect(() => setShowAll(false), [sisetuCode])

  return (
    <Box {...others} sx={{ height: '100%' }}>
      <Stack direction="column" sx={{ height: '100%' }}>
        <Stack direction="row" alignItems="center" paddingX={1} paddingY={1} spacing={0.5}>
          <Typography variant="body1" component="div" color="text.primary" sx={{ textAlign: 'left', flexGrow: 1 }}>関連施設</Typography>
          { summary ? <Typography variant="body2" component="div" color="text.secondary" sx={{ textAlign: 'right' }}>
            全 {numberFormat(summary.list.length)} 施設 / 延べ {numberFormat(round(summary.total, 1))} 人
          </Typography> : <></> }
        </Stack>

          { summary ? (
            <Stack
              direction="column"
              spacing={1}
              sx={{
                flexGrow: 1,
                overflow: 'auto'
              }}
            >
              { summary.max && summary.list.length > 0 ? (
                <List disablePadding>
                  { (showAll ? summary.list : summary.list.slice(0, INITIAL_SHOW_COUNT)).map((r, i) => (
                    <ListRecordWithBar
                      key={`collaborate_${r.sisetuCode}`}
                      index={i}
                      selected={condition.collabo?.code === r.sisetuCode}
                      code={r.sisetuCode}
                      name={r.sisetuName}
                      count={r.kojinCount}
                      max={summary.max}
                      onClicked={(code, name) => onChangeCondition('collabo', { code, name })}
                      icon={
                        <Tooltip title='施設を開く'>
                          <OutboundIcon 
                            sx={{
                              fontSize: (i === 0) ? "100%" : (i < 3) ? "90%" : (i < 5) ? "75%" : "60%"
                            }}
                            onClick={(ev) => {
                              ev.preventDefault()
                              onSisetuOpen(r.sisetuCode)
                            }}
                          />
                        </Tooltip>
                      }
                    />
                  )) }
                  { !showAll && summary.list.length > INITIAL_SHOW_COUNT && <Button fullWidth onClick={() => setShowAll(true)}>すべて表示</Button> }
                </List>
              ) : (
                <Box padding={1}><Alert severity="info">対象が見つかりません.</Alert></Box>
              ) }
            </Stack>
          ) : <></> }
      </Stack>
    </Box>
  )
}